import styled, { keyframes } from "styled-components";

const animacao = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Wrapper = styled.section`
  position: relative;
  width: 100%;
  height: 100%;
  animation: 0.25s ${animacao};
  display: flex;
  flex-direction: column;
  font-size: 20px;

  h3,
  h4,
  p,
  span {
    font-size: 1rem;
    font-weight: 500;
    font-family: "Bebas Neue", cursive;
    font-family: "Open Sans", sans-serif;
    font-family: "Poppins", sans-serif;
  }

  .content {
    flex: 1;
  }

  .headerInterno {
    margin: 0 auto;
    text-align: center;
    max-width: 600px;

    h3 {
      margin-bottom: 20px;
      line-height: 2rem;
    }

    h5 {
      margin: 10px 0 30px;
    }
  }

  .botaoIniciar {
    margin: 40px auto;
  }
`;
